export const OrderType = {
  PurchaseOrder: 2,
};